import {Box, Typography} from '@mui/material';
import {UserAccount} from '../../../__generated__/resolvers-types';
import CouponCodeSettings from '../../../components/couponCodeSettings/CouponCodeSettings';
import NotAuthenticatedPage from '../../other/NotAuthenticatedPage';

export interface CouponCodesProps {
  user?: UserAccount | null;
}

export default function CouponCodes({user}: CouponCodesProps) {
  if (!user) {
    return <NotAuthenticatedPage />;
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Coupon Codes
      </Typography>
      <Typography variant="body1" color="text.secondary" paragraph>
        Manage coupon codes for user promotions and access control.
        {user?.permissions?.includes('owner') && ' (Owner access - can manage all coupon codes)'}
      </Typography>
      <CouponCodeSettings />
    </Box>
  );
}
